import { useSettings } from '@backpackjs/storefront';
import Link from 'next/link';

function CartEmpty(props) {
  const settings = useSettings();
  const cartPage = settings?.cartPage || {};
  const emptyMsg =
    cartPage?.cartEmptyMessage || 'Oops! Your cart is currently empty.';
  const ctaTitle = cartPage?.cta?.title || 'continue shopping';
  const ctaUrl = cartPage?.cta?.url || '/';
  return (
    <div className="cart__empty pt-16 pb-[250px] text-center lg:pt-[150px] lg:pt-[170px]">
      <h1 className="h2 mb-13 mt-0">{emptyMsg}</h1>
      <div>
        <Link href={ctaUrl} passHref>
          <a className="button button--outline inline-block no-underline">
            {ctaTitle}
          </a>
        </Link>
      </div>
    </div>
  );
}

export default CartEmpty;
